import { VisitingType } from "../../services/busy-bee-api/interfaces";


export const visitingTypeOptions = [
  { label: "Індивідуально", value: VisitingType.INDIV, shortLabel: 'Індив' },
  { label: "Групове", value: VisitingType.GROUP, shortLabel: 'Груп' },
  { label: "Індивідуально + Групове", value: VisitingType.INDIV_GROUP, shortLabel: 'Індив+Груп' },
];